import { render } from "./DefContent.vue?vue&type=template&id=27fe04a4&scoped=true"
import script from "./DefContent.vue?vue&type=script&lang=js"
export * from "./DefContent.vue?vue&type=script&lang=js"

import "./DefContent.vue?vue&type=style&index=0&id=27fe04a4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fe04a4"]])

export default __exports__